import CompanyQuotePage from './CompanyQuotePage'
// Uncomment the below to migrate to stateful component
// import CompanyQuotePageContainer from './CompanyQuotePageContainer'

export { CompanyQuotePage }
export default CompanyQuotePage
// Uncomment the below to migrate to stateful component
// export { CompanyQuotePageContainer }
// export default { CompanyQuotePageContainer }
